import { Col, Row } from 'antd'
import React, { useState, useContext, useEffect } from 'react';
import { UserContext } from "../../App.js";
import konsole from '../../network/konsole.js';
import Services from '../../network/Services';
import commonLib from '../../control/commonLib';
import "./communication.css"
import { AddcommunicationNewModal } from './CommunicationModal/AddcommunicationNewModal.js';
import CommunicationNewTable from './CommunicationNewTable.js';


const ConstCommunication = ({ isOn, setIsOn, ...props }) => {

    const [showAddModal, setShowAddModal] = useState(false)
    const [GetCommMediumData, setCommMediumData] = useState([]);
    const [search, setSearch] = React.useState('');
    const { setLoader } = useContext(UserContext)
    const [subtenantID, setSubtenantID] = useState()
    const [emptyState, setEmptyState] = useState()


    useEffect(() => {
        let subtenantIDd = commonLib.getSessionStoarge("subtenantId")
        setSubtenantID(subtenantIDd)
        GetCommMediumPathApiFuction(subtenantIDd)

    }, [subtenantID])

    const handleSearch = (event) => {
        setSearch(event.target.value);
    };

    const handleClose = () => {
        setEmptyState({})
        setShowAddModal(false);
    }

    const addEditModalFun = () => {
        setShowAddModal(true)

    }

    const GetCommMediumPathApiFuction = (subtenantIDd) => {
        setLoader(true)
        const promises = Services.GetCommMediumPathApi2(true,subtenantIDd)
        promises.then((response) => {
            setCommMediumData(response.data.data);
            setEmptyState({})
            setLoader(false)
        })
            .catch((error) => {
                konsole.log("error", error);
                setLoader(false)
            })
            .finally(() => {
                konsole.log("finish");
            });
    };



    return (
        <div>
            <Row >
                <Col span={24}>
                    <Row >
                        <Col span={24} ></Col>
                    </Row>
                    <Row gutter={[32, 8]} align="middle" style={{paddingTop:"15px"}}>

                        <Col flex="auto">
                            <div
                                style={{
                                    display: "flex",
                                    border: "1px solid #474747",
                                    height: "44px",
                                    alignItems: "center",
                                    borderRadius: "2px"
                                }}>
                                <img
                                    className="ms-2"
                                    style={{
                                        padding: "2px",
                                        height: "20px",
                                        marginRight: "2px",
                                        marginLeft: "4px"
                                    }}
                                    src="/search icon.png"
                                />
                                <input
                                    className="form-control newInput searchBox"
                                    style={{
                                        border: "none",
                                        outline: "none",
                                        flex: 1,
                                        height: "100%",
                                        borderRadius: "2px"
                                    }}
                                    type="text"
                                    placeholder="Search for Template Name"
                                    onChange={handleSearch}
                                />
                            </div>
                        </Col>

                      
                                <Col flex="none" className='pe-0'>
                                    <div
                                        style={{
                                            display: "inline-flex",
                                            backgroundColor: "#e8e8e8",
                                            borderRadius: "2px",
                                            padding: "4px",
                                            height:"44px",
                                            gap: "2px",
                                            flexShrink: 0
                                        }}>
                                        <button
                                            onClick={() => setIsOn(false)}
                                            style={{
                                                padding: "6px 10px",
                                                borderRadius: "1.5px",
                                                border: "none",
                                                cursor: "pointer",
                                                fontWeight: "normal",
                                                fontSize: "14px",
                                                backgroundColor: !isOn ? "#6e0f21" : "transparent",
                                                color: !isOn ? "#fff" : "#444",
                                                transition: "all 0.2s ease"
                                            }}>
                                            Communication
                                        </button>

                                        <button
                                            onClick={() => setIsOn(true)}
                                            style={{
                                                padding: "6px 10px",
                                                borderRadius: "1.5px",
                                                border: "none",
                                                cursor: "pointer",
                                                fontWeight: "bold",
                                                fontSize: "14px",
                                                backgroundColor: isOn ? "#6e0f21" : "transparent",
                                                color: isOn ? "#fff" : "#444",
                                                transition: "all 0.2s ease"
                                            }}
                                        >
                                            Content
                                        </button>
                                    </div>
                                </Col>
                        <Col flex="none">
                            <div className="d-flex justify-content-end" style={{ flexShrink: 0}}>
                                <button style={{ fontWeight: "bold", fontSize: "14px",}} className="Add-Edit-btn text-white" type="submit" onClick={addEditModalFun}>
                                    ADD
                                </button>
                            </div>
                        </Col>

                        {showAddModal && (
                            <AddcommunicationNewModal
                                showAddModal={showAddModal}
                                setShowAddModal={setShowAddModal}
                                GetCommMediumPathApiFuction={GetCommMediumPathApiFuction}
                                GetCommMediumData={GetCommMediumData}
                            />
                        )}
                    </Row>
                    <Row className='mt-2'>
                        <Col span={24}>
                            <CommunicationNewTable search={search} GetCommMediumData={GetCommMediumData} GetCommMediumPathApiFuction={GetCommMediumPathApiFuction} />
                        </Col>
                    </Row>

                </Col>
            </Row>
        </div>
    )
}

export default ConstCommunication